import {
  Component,
  ViewEncapsulation,
  OnInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  inject,
  DestroyRef
} from '@angular/core';
import {
  Router,
  RouterModule
} from '@angular/router';
import { DataService, GetSiteDataQuery, SharedService } from '@ng-chronicles/shared/data-access';
import AOS from '@dcasia/aos';
import { HeaderComponent, SiteInformationComponent } from '@ng-chronicles/shared/ui';
import { BackgroundGlitchComponent } from './components/background-glitch/background-glitch.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, signal } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    SiteInformationComponent,
    BackgroundGlitchComponent,
  ]
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'ng-chronicles';
  backgroundImages = signal<any[]>([]);
  contentView = signal(true);
  data$: Observable<GetSiteDataQuery['sites'][number] | undefined>;

  private readonly router = inject(Router);
  private readonly _sharedService = inject(SharedService);
  private readonly _dataService = inject(DataService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this._sharedService.changeEmitted$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.router.navigate([value]);
    });

    this.getData();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      AOS.init({
        duration: 800,
        delay: 200,
      });
    }
  }

  getData(): void {
    this.data$ = this._dataService.getSiteDataData().pipe(
      map((data) => (data as GetSiteDataQuery | undefined)?.sites?.[0] as GetSiteDataQuery['sites'][number] | undefined),
      tap((data) => {
        const images = (data?.backgroundImages || []).map((image) => ({
          mobile: `url(${image?.mobile_url})`,
          tablet: `url(${image?.tablet_url})`,
          desktop: `url(${image?.url})`,
        }));
        this.backgroundImages.set(images);
      }),
      takeUntilDestroyed(this.destroyRef)
    );
  }

  toggleContentView(): void {
    this.contentView.update(v => !v);
  }
}
